module.exports = __webpack_public_path__ + "img/forum-jx.7e0dcfd1.png";